module.exports = __webpack_public_path__ + "media/images/icons/twotone/star-e20fe29857bdc8f75f1bdc353871a3e8.svg";